import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const problems = ['Pasás horas buscando patrones', 'Nunca sabés qué proyecto empezar', 'Te frustran tutoriales incompletos', 'Siempre terminás haciendo lo mismo', 'Querés inspiración constante', 'Querés crear piezas para vender', 'Buscás todo organizado en un solo lugar'];
export function Problem() {
  return <section className="py-12 px-6 bg-white" data-id="element-184">
      <div className="max-w-3xl mx-auto" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-186">
          <h2 className="text-2xl md:text-4xl font-bold text-dark mb-2" data-id="element-187">
            ESTA BIBLIA DEL CROCHET{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-188">
              ES PARA VOS SI...
            </span>
          </h2>
          <p className="text-dark/70 text-sm md:text-base mb-4 font-medium" data-id="element-189">
            Todo lo que hoy te hace perder tiempo, esta biblioteca lo resuelve.
          </p>
          <div className="w-16 h-[2px] bg-gold mx-auto" data-id="element-190"></div>
        </motion.div>

        <div className="space-y-3" data-id="element-191">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-center gap-3 p-3 md:p-4 rounded-xl bg-cream/30 border border-rose-light/20 shadow-sm hover:shadow-soft transition-shadow" data-id="element-192">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-rose-light/40 flex items-center justify-center text-rose-deep" data-id="element-193">
                <ArrowRight className="w-3 h-3" data-id="element-194" />
              </div>
              <p className="text-base md:text-lg text-dark/80 font-medium" data-id="element-195">
                {problem}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}